import { render, staticRenderFns } from "./JSONataEditor.vue?vue&type=template&id=61d2100a&scoped=true"
import script from "./JSONataEditor.vue?vue&type=script&lang=js"
export * from "./JSONataEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d2100a",
  null
  
)

export default component.exports